module.exports = __webpack_public_path__ + "img/logo--mts-icon-full.12b304a.svg";